import { render, staticRenderFns } from "./PrivilegeInformation.vue?vue&type=template&id=e3ff7ba6&"
import script from "./PrivilegeInformation.vue?vue&type=script&lang=js&"
export * from "./PrivilegeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports